import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import _ from 'lodash';
// import useScrollTrigger from '@material-ui/core/useScrollTrigger'
// import Slide from '@material-ui/core/Slide'
import Toolbar from '@material-ui/core/Toolbar';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import {
    AppBar,
    GridContainer,
    GridItem,
    IconButton,
    GoBackButton,
    NoticeIcon,
    DeleteIcon,
    MessageIcon,
    // SearchIcon,
} from '../index';

import { GET_UNREAD_NOTIFICATIONS_COUNT } from '../../services/index';
import { GET_PATIENT_UNREAD_MESSAGES_COUNT } from '../../services/patient';

import socket from '../../socket';

import { alertError } from '../../redux/stateActions';

const FirdayLogo = '/resources/images/friday_logo.svg';

const messageSound = '/resources/audios/messageSound.mp3';
const notificationSound = '/resources/audios/notificationSound.mp3';

export const Header = ({
    showNotice,
    showMessage,
    style,
    showGoBack1,
    onClickGoBack,
    disabledMessage,
    onDelete,
    disabledDelete,
    showGoBack2,
    children,
    childrenContainerStyle,
    // onSearch,
    refetchMesssgeCount,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const mobileS = useMediaQuery('(max-width:374.95px)');

    const user = useSelector((state) => state.user);
    const messages = useSelector((state) => state.messages);

    const [messageAudio] = useState(new Audio(messageSound));
    const [notificationAudio] = useState(new Audio(notificationSound));

    const [notiCount, setNotiCount] = useState(0);

    const currentPath = `/${location.pathname.split('/')[1]}`;

    const [patientId, setPatientId] = useState(null);
    const [providerAvatar, setProviderAvatar] = useState(null);

    useEffect(() => {
        if (!_.isEmpty(user.patient)) {
            setPatientId(user.patient.id);
            setProviderAvatar(user.patient?.hospital?.avatar?.url);
        }
    }, [user]);

    // function HideOnScroll(props) {
    //     const { children, window } = props
    //     const trigger = useScrollTrigger({
    //         target: window ? window() : undefined,
    //     })

    //     return (
    //         <Slide appear={false} direction='down' in={!trigger}>
    //             {children}
    //         </Slide>
    //     )
    // }

    /*---------- Get unread notifications count -----------*/
    const {
        data: getNotiCountData,
        error: getNotiCountError,
        refetch: getNotiCountRefetch,
    } = useQuery(GET_UNREAD_NOTIFICATIONS_COUNT, {
        variables: { id: patientId },
        skip: _.isEmpty(user) || !showNotice || !patientId,
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (getNotiCountError) {
            dispatch(alertError(`get notification Errors: ${getNotiCountError.message}`));
        }
        if (getNotiCountData) {
            setNotiCount(getNotiCountData.notificationsConnection.aggregate.count);
        }
    }, [getNotiCountError, getNotiCountData]);

    /*---------- Get unread messages count -----------*/
    const [messagesCount, setMessagesCount] = useState(0);

    const {
        data: getMessagesCountData,
        error: getMessagesCountError,
        refetch: getMessagesCountRefetch,
    } = useQuery(GET_PATIENT_UNREAD_MESSAGES_COUNT, {
        variables: { id: patientId },
        skip: _.isEmpty(user) || !showNotice || !patientId,
    });

    useEffect(() => {
        if (getMessagesCountError) {
            dispatch(alertError(`get notification Errors: ${getMessagesCountError.message}`));
        }
        if (getMessagesCountData) {
            setMessagesCount(getMessagesCountData.patient.messages.length);
        }
    }, [getMessagesCountError, getMessagesCountData]);

    useEffect(() => {
        if (showNotice) {
            socket.on('newNotification', () => {
                getNotiCountRefetch();
                notificationAudio.volume = 0.5;
                notificationAudio.play();
            });
        }
    }, [showNotice]);

    useEffect(() => {
        if (showMessage) {
            socket.off('messageUpdate');

            socket.on('messageUpdate', (data) => {
                getMessagesCountRefetch();
                /* will not play sound if 
                    - chat window not open 
                    - currently chat with sender
                    - in message route
                    - this user is sender
                    */
                if (messages.id !== data?.sender && data?.sender !== user.patient.id) {
                    messageAudio.play();
                }
            });

            if (refetchMesssgeCount) {
                getMessagesCountRefetch();
            }
        }
    }, [showMessage, refetchMesssgeCount, messages]);

    return (
        <Fragment>
            {/* <HideOnScroll> */}
            <AppBar style={style}>
                <Toolbar disableGutters>
                    <div
                        style={{
                            width: '100%',
                            display: 'grid',
                            alignItems: 'center',
                            // justifyContent: 'space-between',
                            gridTemplateColumns: showGoBack1
                                ? // 'repeat(3,1fr)'
                                  '1fr max-content 1fr'
                                : '1fr auto',
                        }}
                    >
                        {showGoBack1 && (
                            <div>
                                {onClickGoBack && (
                                    <GoBackButton onClick={onClickGoBack} mobileS={mobileS} />
                                )}
                            </div>
                        )}
                        <div style={childrenContainerStyle}>
                            {children ? (
                                children
                            ) : (
                                <div
                                    style={{
                                        display: 'flex',
                                        columnGap: '20px',
                                        maxHeight: '35px',
                                    }}
                                >
                                    <img src={FirdayLogo} alt="friday" />
                                    {providerAvatar && (
                                        <img
                                            src={providerAvatar}
                                            alt="provider-avatar"
                                            style={{ maxHeight: '35px', width: 'auto' }}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                            }}
                        >
                            {showNotice && (
                                <IconButton
                                    margin="0  0 0 10px"
                                    onClick={() => {
                                        history.push({
                                            pathname: `/notification`,
                                            state: {
                                                prevPath: currentPath,
                                            },
                                        });
                                    }}
                                >
                                    <StyledBadge
                                        badgeContent={notiCount}
                                        color="secondary"
                                        overlap="rectangular"
                                    >
                                        <NoticeIcon fill="gray1" />
                                    </StyledBadge>
                                </IconButton>
                            )}
                            {showMessage && !disabledMessage && (
                                <IconButton
                                    margin="0  0 0 10px"
                                    onClick={() => history.push(`/message`)}
                                    disabled={disabledMessage}
                                >
                                    <StyledBadge
                                        badgeContent={messagesCount}
                                        color="secondary"
                                        overlap="rectangular"
                                    >
                                        <MessageIcon fill="black" />
                                    </StyledBadge>
                                </IconButton>
                            )}
                            {onDelete && !disabledDelete && (
                                <IconButton
                                    margin="0  0 0 10px"
                                    onClick={onDelete}
                                    disabled={disabledDelete}
                                >
                                    <DeleteIcon fill="black" />
                                </IconButton>
                            )}
                            {/* {onSearch && (
                                    <IconButton margin="0  0 0 10px" onClick={onSearch}>
                                        <SearchIcon fill="gray1" />
                                    </IconButton>
                                )} */}
                        </div>
                    </div>
                </Toolbar>
                {showGoBack2 && (
                    <GridContainer>
                        <GridItem justifyContent="flex-start">
                            <GoBackButton $text onClick={onClickGoBack} />
                        </GridItem>
                    </GridContainer>
                )}
            </AppBar>
            {/* </HideOnScroll> */}
            {/* <ToolbarMargin /> */}
        </Fragment>
    );
};

Header.propTypes = {
    showNotice: PropTypes.bool,
    showMessage: PropTypes.bool,
    style: PropTypes.object,
    showGoBack1: PropTypes.bool,
    onClickGoBack: PropTypes.func,
    title: PropTypes.string,
    titleFontSize: PropTypes.string,
    disabledMessage: PropTypes.bool,
    onDelete: PropTypes.func,
    disabledDelete: PropTypes.bool,
    showGoBack2: PropTypes.bool,
    onSearch: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    refetchMesssgeCount: PropTypes.number,
    childrenContainerStyle: PropTypes.object,
    children: PropTypes.any,
};

const StyledBadge = withStyles(() => ({
    badge: {
        color: 'white',
    },
}))(Badge);
